"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChevronUpCircleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M16,9 C16,12.8659932 12.8659932,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 C12.8659932,2 16,5.13400675 16,9 Z M15,9 C15,5.6862915 12.3137085,3 9,3 C5.6862915,3 3,5.6862915 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 Z M10.9091229,9.84191541 L9,8.001 L7.09461968,9.83699469 C6.89242154,10.0318297 6.57270638,10.0330563 6.36901915,9.83977864 C6.17314737,9.653917 6.16503255,9.34446093 6.35089419,9.14858916 C6.3538512,9.1454729 6.35684915,9.14239574 6.35988726,9.13935849 L9,6.5 L11.6342471,9.13499977 C11.827677,9.328485 11.8276322,9.64214175 11.634147,9.83557171 L11.6296445,9.84001581 C11.4294042,10.0351501 11.1103893,10.0359912 10.9091229,9.84191541 Z" })));
};
ChevronUpCircleSmall.displayName = 'ChevronUpCircleSmall';
exports.default = ChevronUpCircleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChevronUpCircleSmall.js.map